import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from 'vue'
import ProjectDeliver from '@/views/ViewsComponents/projectDeliver/ProjectDeliver.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeName = ref('first')


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, {
      type: "border-card",
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "待交付",
          name: "first"
        }, {
          default: _withCtx(() => [
            _createVNode(ProjectDeliver, { "is-paid": false })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "已交付",
          lazy: "",
          name: "second"
        }, {
          default: _withCtx(() => [
            _createVNode(ProjectDeliver, { "is-paid": true })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})